export const nbRails = 3;
export const gameWindowSize = ( () => {
    const defaultRatio = 5 / 3;
    if ( window.innerWidth * defaultRatio > window.innerHeight ) {
        return {
            width: window.innerHeight / defaultRatio,
            height: window.innerHeight,
        };
    }

    return {
        width: window.innerWidth,
        height: window.innerHeight,
    };
} )();


export const tearWidth = 30;
export const tearDelay = 100;
export const tearFrequency = 4;

export const animalWidthProportion = 30;
export const railPadding = 20;
export const boatWidthProportion = 45;
export const boatPhysicsBottomMargin = 70;

export const pauseWidth = 25; // in px
export const pauseTopMargin = 5;
export const pauseRightMargin = 5;

export const displayScoreDigit = 5;
export const scoreNewAnimal = 200;
export const scoreCouple = 400;
export const scoreAnimal = 50;

export const diffBaseSpawnDelay = 800;
export const diffBaseAnimalVelocity = 340;
export const diffBaseTearVelocity = 300;

export const difficultyIncreaseStep = 0.02;
export const difficultyIncreaseEventDelay = 2000;
export const difficultyStart = 1;
export const difficultyLimit = 2.5;

export const initDelay = 2000;
